package com.schoolconnect.app.feature.examresults

import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.feature.common.compareBySmartText

data class ExamResultFilters(
    val exam: String = "",
    val className: String = "",
    val status: String = ""
)

data class ExamResultRowUi(
    val id: String,
    val examId: String,
    val exam: String,
    val examType: String,
    val date: String,
    val endDate: String,
    val className: String,
    val examStatus: String,
    val marksEntered: Int,
    val totalMarks: Int,
    val status: String
)

data class ExamResultsUiState(
    val rows: List<ExamResultRowUi> = emptyList(),
    val searchQuery: String = "",
    val filters: ExamResultFilters = ExamResultFilters(),
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val sortField: ExamResultsSortField = ExamResultsSortField.EXAM,
    val sortAscending: Boolean = true,
    val totalCount: Int = 0,
    val isLoading: Boolean = false,
    val errorMessage: String = ""
) {
    val examOptions: List<String> get() = rows.map { it.exam }.distinct().sorted()
    val classOptions: List<String> get() = rows.map { it.className }.distinct().sorted()
}

sealed interface ExamResultsUiEvent {
    data class SearchChanged(val query: String) : ExamResultsUiEvent
    data class FiltersChanged(val filters: ExamResultFilters) : ExamResultsUiEvent
    data object FiltersApplied : ExamResultsUiEvent
    data object FiltersReset : ExamResultsUiEvent
    data class PageChanged(val pageIndex: Int) : ExamResultsUiEvent
    data class PageSizeChanged(val pageSize: Int) : ExamResultsUiEvent
    data class DeleteClicked(val examId: String) : ExamResultsUiEvent
    data class UpdateClicked(val resultId: String, val exam: com.schoolconnect.app.feature.exams.ExamRowUi) : ExamResultsUiEvent
    data class SortChanged(val field: ExamResultsSortField) : ExamResultsUiEvent
}

enum class ExamResultsSortField { EXAM, DATE, CLASS, MARKS_ENTERED, STATUS }

internal fun examResultsComparator(field: ExamResultsSortField): Comparator<ExamResultRowUi> = when (field) {
    ExamResultsSortField.EXAM -> compareBySmartText { it.exam }
    ExamResultsSortField.DATE -> compareBySmartText { it.date }
    ExamResultsSortField.CLASS -> compareBySmartText { it.className }
    ExamResultsSortField.MARKS_ENTERED -> compareBy { it.marksEntered }
    ExamResultsSortField.STATUS -> compareBySmartText { it.status }
}
